export default __webpack_public_path__ + "static/media/Roboto-Light.df0f59d8.woff";